import React from 'react'
import PropTypes from 'prop-types';
import I18n from 'jsx!Component/I18n'

function Thead(props) {
  function onSort(field, e) {
    e.preventDefault();
    props.onSort && props.onSort(field);
  }

  let cols = props.labels.map(function (item, key) {
    if (item.sortable) {
      let sort = '';
      if (item.name === props.sortBy) {
        sort = props.sortDir === 'DESC' ? '\u25BC' : '\u25B2';
      }
      return (
        <th key={key}>
          <a href="#" onClick={onSort.bind(null, item.name)}>
            <I18n message={item.label}/>
          </a>
          {sort}
        </th>
      );
    } else if (props.filterField && ((props.filterField instanceof Array && props.filterField.indexOf(item.name) >= 0) || item.name === props.filterField)) {
      return (
        <th key={key}>
          <input className="table-filter" placeholder={I18n.message(item.label)}
                 onChange={props.filterChange.bind(null, item.name)}/>
        </th>
      );
    } else {
      return (
        <th key={key}><I18n message={item.label}/></th>
      );
    }
  });

  return (
    <thead>
    <tr>
      {cols}
    </tr>
    </thead>
  );
}

Thead.defaultProps = {
  onSort: null,
  sortBy: null,
  sortDir: null,
  filterField: null,
  filterChange: null,
  labels: []
};

Thead.propTypes = {
  onSort: PropTypes.func,
  sortBy: PropTypes.string,
  sortDir: PropTypes.string,
  labels: PropTypes.array
};

export default Thead;



// WEBPACK FOOTER //
// ./src/js/Component/Table/Thead.jsx